import script from "./vtimeframeselector.vue?vue&type=script&setup=true&lang=js"
export * from "./vtimeframeselector.vue?vue&type=script&setup=true&lang=js"

import "./vtimeframeselector.vue?vue&type=style&index=0&id=16cd59e3&lang=css"

const __exports__ = script;

export default __exports__